import { useTranslation } from 'react-i18next';
import type { BuyListDetailTally } from './types';

export function useTallyLabel() {
  const { t } = useTranslation('inventory');
  return (tally: BuyListDetailTally, tallyCount?: number | null) =>
    tally.__typename === 'CannedBuyListTally'
      ? t('inventory.buy_list.tallies.canned_name_count', {
          name: tally.cannedTally.name,
          tallyCount: tallyCount ?? tally.tallyCount,
        })
      : t('inventory.buy_list.tallies.random_name');
}
